class Voyageurs extends Inscription {
	/// Il s'agit de la fonction appelée sur chacune des pages du tunnel
	initialize() {

		let self = this;

		/// On lance les fonctions génériques (récap, entête)
		super.initialize();

		/// On appelle la class gérant les passagers (front<=>back)
		const passager = new passagerInscription(config);
		passager.eventChangeNbrePassager();

		/// Si l'on est sur un code type circuit famille,
		/// on desactive le bouton de validation s'il n'y a pas d'enfants
		/// _isFamilyTravelers().hasChildrenTravelers = true | false
		// if (this._isFamilyTravelers().isFamily) {
		// 	this._updateBtn();
		// 	document.getElementById('voyageursForm').addEventListener('change', function () {
		// 		self._updateBtn();
		// 	});
		// }

		/// Événement click btn option
		/// (Pas de pose d'option possible sur les voyages liberté)
		/// Pas de pose d'option pour les départs France 2022
		(!config.liberte && config.poseOption) && self.eventClickInscription(this.config.btnOption);

		/// Événement click btn inscription
		this.config.btnInscription !== null && self.eventClickInscription(this.config.btnInscription);
	}

	/// @event
	/// Click valider : popup ou submit
	eventClickInscription(btn) {
		let self = this;
		let msg = {
			popupNoChildrens: {
				'title': 'Aucun enfant ou adolescent parmi les passagers',
				'texte': `Merci de choisir un nombre d'enfants ou d'adolescents.`
			},
			popupModificationNbrePassagers: {
				'title': 'Votre demande initiale a été modifiée',
				'texte': `<p>Vous avez modifié le nombre de voyageurs par rapport à votre demande initiale.<br> Les prix seront actualisés en conséquence.</p>`
			},
			popupDevis: {
				'title': 'Demander un devis',
				'texte': `<p>Pour le nombre de personnes que vous venez de renseigner, nous vous proposons de remplir la demande de devis qui suit</p><p><a class="underline" href="${config.url.devis}">Demande de devis</a><p><p> Un conseiller prendra contact avec vous très rapidement pour finaliser votre projet.</p>`
			}
		}

		btn.addEventListener('click', function (e) {

			e.preventDefault();

			/// On est sur un type circuit = 2 && le nombre d'enfants (Ado+enfant+bébé) est = 0
			if (self._isFamilyTravelers().isFamily && !self._isFamilyTravelers().hasChildrenTravelers) {
				/// Mise à jour du btn de validation
				//self._stateValidButton(self._isFamilyTravelers().hasChildrenTravelers, btn);
				/// Lancement de la modale
				modalPopup.init(msg.popupNoChildrens.texte, msg.popupNoChildrens.title);
			}
			/// Si l'on est sur un circuit liberté
			else if (self.config.liberte) {
				let nbPax = document.getElementById('HiddenNbVoyageurs').value;
				const utilities = new utilitiesInscription(config);

				utilities._poursuiteInscriptionIndiv(nbPax).then(response => {

					if (response) {
						self._submitForm('voyageursForm');

					} else {
						modalPopup.init(msg.popupDevis.texte, msg.popupDevis.title);
					}

				});

			}
			/// Sinon on soumet le formulaire
			else {
				document.getElementById('HiddenIsOption').value = e.target.id === 'btnOption';
				self._submitForm('voyageursForm');
			}
		})
	}

	/// @event
	/// Si l'on est sur un circuit de type famille, on met à jour le bouton de validation
	// _updateBtn() {
	// 	let self = this;
	// 	this.config.btnOption !== null && self._stateValidButton(self._isFamilyTravelers().hasChildrenTravelers, this.config.btnOption);
	// 	this.config.btnInscription !== null && self._stateValidButton(self._isFamilyTravelers().hasChildrenTravelers, this.config.btnInscription);
	// }

	/// @return obj{}
	/// Fonction retournant un objet indiquant :
	///  isFamily : true | false > est-ce un voyage famille ?
	/// nbreChildren : la Σ du nombre d'ados, d'enfants et de bébés lors de l'appel de la fonction
	/// hasChildrenTravelers : true | false > utile pour le passage à l'étape 2
	_isFamilyTravelers() {
		let obj = {};

		obj.isFamily = config.codeTypeCircuit === 2;
		let idListSelectChildren = ['nbreAdo', 'nbreEnfant', 'nbreBebe'];
		let nbreChildren = 0;
		idListSelectChildren.forEach(id => {
			let el = document.getElementById(id);
			if (el != null) {
				nbreChildren += parseInt(el.value);
			}
		});
		obj.nbreChildren = nbreChildren;
		obj.hasChildrenTravelers = nbreChildren > 0;

		return obj;
	}
}